import { AppDispatch, AppThunk, GetState } from '@om-fe/core/core/types';
import {
    apiSubscribeAction,
    apiUnsubscribeAction,
    attachReducerAction,
    detachReducerAction,
} from '@om-fe/core/utils/action';
import getSlice from '@om-fe/core/utils/get-slice';
import { SpecialMatchListSetFilterDataAction, SpecialMatchListActions, SpecialMatchListSetLoadingData, SpecialMatchListTopicModel, SpecialMatchListStoreModel } from './special-match-list.constants';
import { getSpecialMatchListSliceName, getSpeciclMatchListTopic } from './special-match-list.utils';
import { specialMatchListReducerCreator } from './special-match-list.reducer';
import { BonusType } from '../../../match-list-group/match-list-special-header';

export const specialMatchListSetLoadingData = (slice: string, isLoadingMoreData: boolean = false): SpecialMatchListSetLoadingData => ({
    type: SpecialMatchListActions.SetLoadingData,
    meta: {
        slice,
    },
    payload: {
        isLoadingMoreData,
    },
});

export const specialMatchListSetFilterData = (
    slice: string,
): SpecialMatchListSetFilterDataAction => ({
    type: SpecialMatchListActions.SetFilterData,
    meta: {
        slice,
    }
});

export const specialGroupsMatchListSetFilterData = (
    slice: string,
): SpecialMatchListSetFilterDataAction => ({
    type: SpecialMatchListActions.SetFilterData,
    meta: {
        slice,
    }
});

export const getSpecialMatchList = (
    instanceId: string,
    bonusType: BonusType,
) => (dispatch: AppDispatch) => {
    const slice: string = getSpecialMatchListSliceName(instanceId);
    const topic: SpecialMatchListTopicModel = getSpeciclMatchListTopic(bonusType) as SpecialMatchListTopicModel;

    dispatch(attachReducerAction(slice, specialMatchListReducerCreator(instanceId)));

    dispatch(specialMatchListSetFilterData(
        slice,
    ));

    dispatch(apiSubscribeAction(topic.path, {}, slice));
};

export const removeSpecialMatchList = (
    instanceId: string,
    bonusType: BonusType,
): AppThunk => (dispatch: AppDispatch, getState: GetState) => {
    const slice: string = getSpecialMatchListSliceName(instanceId);
    const matchListState: SpecialMatchListStoreModel | undefined = getSlice<SpecialMatchListStoreModel>(getState(), slice);

    if (!matchListState) {
        return;
    }

    const topic: SpecialMatchListTopicModel = getSpeciclMatchListTopic(bonusType) as SpecialMatchListTopicModel;

    dispatch(detachReducerAction(slice));
    dispatch(apiUnsubscribeAction(topic.path, {}, slice));
};